// ##### 25-02-12 Komarov
import uniqueId from 'lodash.uniqueid';
import React from 'react';
import { useSelector } from 'react-redux';
// ##### 25-05-21 Komarov
import Star from '../../../../Library/Icons/star';
import { getDomain } from '../../../Helpers/urls';
// ##### Komarov 2025-07-26
import Image from '../../../../Library/PageDevices/CartGallery/Image';
// ##### Komarov 2025-09-15

// ##### Komarov 2025-07-14
const HotelItemContent = ({
  ulCLassName,
  liClassName,
  liImageClassName,
  divHotelNameStarRatingClassName,
  divHotelAddressClassName = null,
  width,
  height,
  // ##### 25-04-21 Komarov
  id, // hotel's id
}) => {
  const deviceType = useSelector(state => state.deviceType);
  // ##### 2025-09-11 Komarov
  const hotelcontent = useSelector(state => state.hotelcontent.hotelcontent);
  const cityName = hotelcontent.data.ci_title.toUpperCase();
  // ##### 25-04-21 Komarov
  const stars = Array.from(hotelcontent.data.hotels[id].star_name);
  const hotelTitle = hotelcontent.data.hotels[id].ho_title.toUpperCase();
  const hotelAddress = hotelcontent.data.hotels[id].address;
  const main_image = hotelcontent.data.hotels[id].main_image;
  const currentWebProtocol = process.env.REACT_APP_SMART_PROTOCOL || 'https://';
  // ##### 25-04-03 Komarov
  const hotelImageSrcStub = `${currentWebProtocol}${getDomain(process.env.REACT_APP_SMART_URL)}/images_symlink/hotel/0/Hotel_when_no_image.jpeg`;
  // ##### Komarov 2025-09-15

  const getMainImageSrc = main_image => {
    if (!main_image || main_image.length === 0) {
      // ##### 25-04-21 Komarov
      console.warn("There's no images for hotel with id", id);
      return hotelImageSrcStub;
    } else if (main_image[0].includes('localhost')) {
      // ##### 25-04-21 Komarov
      console.warn("There's no images for hotel with id", id);
      return hotelImageSrcStub;
    } else if (
      // ##### 25-03-26 Komarov: убрал требование к формату картинок webp
      !main_image[0].includes(`/${deviceType}/`) /*||
      !main_image[0].includes(".webp")*/
    ) {
      let fixedHotelImageSrc = main_image[0];
      if (!main_image[0].includes(`/${deviceType}/`)) {
        fixedHotelImageSrc = `${fixedHotelImageSrc.slice(0, fixedHotelImageSrc.indexOf('images_symlink') + 'images_symlink'.length)}/${deviceType}${fixedHotelImageSrc.slice(fixedHotelImageSrc.indexOf('images_symlink') + 'images_symlink'.length)}`;
      }
      // ##### 25-03-26 Komarov: убрал требование к формату картинок webp
      return fixedHotelImageSrc;
    }
    return main_image[0];
  };
  const hotelMainImageSrc = getMainImageSrc(main_image);

  return (
    <ul className={ulCLassName} data-component="HotelItemContent">
      <li
        key={uniqueId()}
        className={liClassName}
        style={{ gridRow: '1', gridColumn: '1', order: 1 }}
      >
        <div className={divHotelNameStarRatingClassName}>
          <h3
            style={{
              // ##### 24-08-14 Komarov
              // fontSize: "27px",
              fontSize: '22px',
              color: '#001959',
              fontWeight: 'bold',
              marginRight: '2vw',
            }}
          >
            {hotelTitle}
          </h3>
        </div>
      </li>
      <li
        key={uniqueId()}
        className={liClassName}
        style={{ gridRow: '1', gridColumn: '2/3', order: 2 }}
      >
        {/* ##### 24-10-18 Komarov */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <div className={divHotelNameStarRatingClassName}>
            {stars.map(() => (
              <span
                key={uniqueId()}
                style={{
                  marginLeft: '0.1vw',
                  marginRight: '0.1vw',
                }}
              >
                <Star />
              </span>
            ))}
          </div>
        </div>

        {/* ##### 24-03-21 Komarov */}
        <div className={divHotelAddressClassName}>
          <span style={{ fontWeight: 'bold' }}>{cityName}</span> -{' '}
          {hotelAddress}
        </div>
      </li>
      <li
        key={uniqueId()}
        className={liImageClassName}
        style={{ gridRow: '2', gridColumn: '1', order: 3 }}
      >
        {/* ##### 25-04-03 Komarov */}
        <Image
          src={hotelMainImageSrc}
          alt="Hotel"
          style={{
            width,
            height,
          }}
          // ##### 25-04-21 Komarov
          id={id} // hotel's id
        />
      </li>
    </ul>
  );
};

export default HotelItemContent;
